import styled, { css } from "styled-components";
import SearchBar from "ui/common/components/input/SearchBar/SearchBar";

export const SearchBarRoot = styled(SearchBar)(
    () => css`
        .TextInput {
            height: 35px !important;
            border-radius: 25px !important;
            background-color: transparent !important;
            box-shadow:
                inset 0px 3px 6px #00000014,
                0px 3px 6px #00000029;
            input {
                font-size: 0.8rem !important;
                &::placeholder {
                    font-size: 0.8rem !important;
                    color: #adadadc9 !important;
                }
            }
        }
    `,
);
